import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronMaximizeDiagonalFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.25,3h-4.5c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h3.75v3.75c0,.414,.336,.75,.75,.75s.75-.336,.75-.75V3.75c0-.414-.336-.75-.75-.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M8.25,13.5h-3.75v-3.75c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75v4.5c0,.414,.336,.75,.75,.75h4.5c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconChevronMaximizeDiagonalFill18.js.map